module.exports = __webpack_public_path__ + "static/media/Isologo_login.40f093b6.png";